import SearchIcon from '@mui/icons-material/Search';
import {Icon, InputAdornment, InputBase, styled} from '@mui/material';
import PropTypes from 'prop-types';
import React, {Component} from 'react';

export const LINE_HEIGHT = 40;

const StyledInput = styled(InputBase)(({theme}) => ({
  padding: theme.spacing(0.5),
  backgroundColor: 'transparent',
}));

class QueryInput extends Component {
  static propTypes = {
    'data-qe': PropTypes.string,
    inputRef: PropTypes.func,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.object,
  };

  state = {
    focused: false,
    value: '',
  };

  onChange = event => {
    const {value} = event.target;
    this.props.onChange(value);
    if (!this.isValueDefined()) {
      this.setState({value});
    }
  };

  getValue() {
    return this.isValueDefined() ? this.props.value : this.state.value;
  }

  isValueDefined() {
    return typeof this.props.value !== 'undefined';
  }

  render() {
    return (
      <StyledInput
        autoFocus
        fullWidth
        type="search"
        data-qe={this.props['data-qe']}
        inputRef={this.props.inputRef}
        onBlur={this.props.onBlur}
        onChange={this.onChange}
        onFocus={this.props.onFocus}
        onKeyDown={this.props.onKeyDown}
        placeholder={this.props.placeholder}
        value={this.getValue()}
        startAdornment={
          <InputAdornment position="start">
            <Icon component={this.props.icon || SearchIcon} />
          </InputAdornment>
        }
      />
    );
  }
}

export default QueryInput;
